import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import pro1 from "../../utils/product1.PNG";
import pro2 from "../../utils/product2.PNG";
import pro3 from "../../utils/product3.PNG";
import { useLocation } from "react-router-dom";
import { PDFViewer } from "@react-pdf/renderer";
import QuotationPDF from "./QuotationPDF";
import QuotationPDF_2 from "./QuotationPDF_2";
import QuotationPDF_2_cubix from "./QuotationPDF_2_cubix";
// const QuotationPage = ({ quotationData }) => {

const QuotationPage = () => {
  console.log("inside QuotationPage");
  console.log("QuotationPage mounted");

  let company_code_from_local_storage = localStorage.getItem("companyCode")
    ? localStorage.getItem("companyCode")
    : "-";
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const imageServerPath = API_PATHS[0]?.IMG_API_PATH;
  const [companyCode, setCompanyCode] = useState(null);

  useEffect(() => {
    setCompanyCode(company_code_from_local_storage);
  }, []);

  const location = useLocation();
  
  const selectedLead = location.state?.selectedLead || null;
  const productsInQuotationFromAPI =
    location.state?.productsInQuotationFromAPI || null;
  const vatValue = location.state?.vatValue || null;
  const alreadySentQuotationNumber =
    location.state?.alreadySentQuotationNumber || null;
  const discountValue = location.state?.discountValue || null;
  const salesOrderYesOrNo = location.state?.salesOrderYesOrNo || null;

  console.log("selectedLead >> in quotation page", selectedLead);
  console.log(
    "leadProducts >>in quotation page",
    productsInQuotationFromAPI,
    alreadySentQuotationNumber
  );

  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;

  const [showModal, setShowModal] = useState(false);

  const handlePreview = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  if (companyCode === null) {
    return (
      <div>
        <p>Loading</p>
      </div>
    );
  }

  return companyCode?.trim().toUpperCase() === "SUNRISE" ? (
    <PDFViewer style={{ width: "100%", height: "90vh" }}>
      <QuotationPDF_2
        selectedLead={selectedLead}
        productsInQuotationFromAPI={productsInQuotationFromAPI}
        formattedDate={formattedDate}
        vatValue={vatValue}
        alreadySentQuotationNumber={alreadySentQuotationNumber}
        discountValue={discountValue}
        salesOrderYesOrNo={salesOrderYesOrNo}
        imageApiPath={imageServerPath}
      />
    </PDFViewer>
  ) : (
    <PDFViewer style={{ width: "100%", height: "90vh" }}>
      <QuotationPDF_2_cubix
        selectedLead={selectedLead}
        productsInQuotationFromAPI={productsInQuotationFromAPI}
        formattedDate={formattedDate}
        vatValue={vatValue}
        alreadySentQuotationNumber={alreadySentQuotationNumber}
        discountValue={discountValue}
        salesOrderYesOrNo={salesOrderYesOrNo}
      />
    </PDFViewer>
  );
};

export default QuotationPage;

